<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_6"></a>Sherwood Anderson and Other Famous Creoles
</h1>
<p class="author">William Spratling and William Faulkner</p>
<div class="img_containert">
<img alt="image" src="images/logo.jpg"/>
<a id="page_7"></a><a id="page_8"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?5f66eae1